import { Image, styled, Text } from '@obvio/app'
import { SvgChevronRight } from '@obvio/svg'
import { Stack } from '@obvio/ui'
import { AnimatePresence, motion } from 'framer-motion'
import { useState } from 'react'

import type { AllowUndefinedForOptional } from '@obvio/utils'
import type { ReactElement } from 'react'

const Wrap = styled(Stack)`
  align-items: flex-start;
  width: 100%;
  overflow: hidden;
  * {
    text-align: left;
  }
`

const TitleWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

const HeadWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  > span {
    margin-bottom: ${(theme) => theme.spacing.extraSmall};
  }
`

const SvgArrow = styled(SvgChevronRight)<{ $open: boolean }>`
  transform: rotate(${(_, { $open }) => ($open ? '90deg' : '-90deg')});
`

type AboutPageMemberProps = AllowUndefinedForOptional<{
  imgSrc: string
  thumb: string
  name: string
  title: string
  small?: boolean
  text?: string
}>

export function AboutPageMember({
  imgSrc,
  thumb,
  name,
  title,
  small,
  text,
}: AboutPageMemberProps): ReactElement {
  const [open, setOpen] = useState(false)

  return (
    <Wrap kind="vertical" spacing="extraSmall">
      <div
        style={{
          height: small ? '20rem' : '35rem',
          width: '100%',
          position: 'relative',
        }}
      >
        <Image static img={{ name: imgSrc, ratio: 1, thumb }} layout="fill" />
      </div>
      <HeadWrap onClick={() => setOpen((v) => !v)}>
        <TitleWrap>
          <span>{title}</span>
          {text ? <SvgArrow $open={open} /> : null}
        </TitleWrap>
        <Text tag="h3" as="sub-h1">
          {name}
        </Text>
      </HeadWrap>
      <AnimatePresence>
        {open && text ? (
          <motion.section
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { height: 'auto' },
              collapsed: { height: 0 },
            }}
            transition={{ duration: 0.35 }}
          >
            <Text>{text}</Text>
          </motion.section>
        ) : null}
      </AnimatePresence>
    </Wrap>
  )
}
